import React, { createContext, useState, useEffect, useRef } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import PubSub from 'pubsub-js'
import { useImmer } from 'use-immer';
import CustomerCodingEventService from '../services/CustomerCodingEventService';
import { applicationContextActionCreator, modalActionCreator } from '../store/actions/';
import _ from 'lodash';

export const CustomerContext = createContext();
export const CustomerContextConsumer = CustomerContext.Consumer;

const initFilters = {
    accountId: 0,
    assignedToId: 0,
    eventPriorityId: 0,
    statusId: 0,
    searchText: '',
    searchId: 0,
    requestedServiceId: 0,
    lineOfBusinessId: 0,
    currentPage: 0,
    take: 10,
    skip: 0,
    fetchRefData: true
};

const CustomerContextProvider = (props) => {
    const firstRender = useRef(true);
    const [codingEvents, setCodingEvents] = useImmer([]);
    const [filters, setFilters] = useImmer(initFilters);
    const [filtered, setFiltered] = useImmer(false);
    const [refData, setRefData] = useImmer({
        accounts: [],
        statusRefData: [],
        assignedToRefData: [],
        eventPriorityRefData: [],
        lineOfBusinessRefData: [],
        totalRecords: 0
    });

    const dispatch = useDispatch();

    useEffect(() => {
        firstRender.current = false;
    }, [])

    useEffect(() => {
        const run = !firstRender.current;
        run&&getCodingEvents();
    }, [filters])

    const getCodingEvents = async () => {

        var service = new CustomerCodingEventService();
        
        var callResult = await service.getEvents(filters);

        if (callResult.result) {
            if (filters.fetchRefData) {
                setRefData(_.omit(callResult.model, 'codingEvents'));
            }

            setCodingEvents(callResult.model.codingEvents);
        } else {
            // do error handling
        }
    }

    const showModal = (props, type) => {
        dispatch(modalActionCreator.showModal(props, type));
    }

    const hideModal = () => {
        dispatch(modalActionCreator.hideModal());
    }

    const setFilterValue = (name, value) => {
        setFilters(draft => {
            draft[name] = value;
            draft.currentPage = 0;
            draft.skip = 0;
        });
        setFiltered(true);
    }

    const pageResults = (newPage) => {
        setFilters(draft => {
            draft.currentPage = newPage;
            draft.skip = newPage * draft.take;
        })
    }

    const resetFilters = () => {
        setFilters(initFilters);
        setFiltered(false);
    }

    return (
        <CustomerContext.Provider value={{
            codingEvents,
            filters,
            setFilterValue,
            resetFilters,
            pageResults,
            filtered,
            refData,
            getCodingEvents,
            showModal,
            hideModal
        }}>
            {props.children}
        </CustomerContext.Provider >
    )
}

export default CustomerContextProvider;